import { render, staticRenderFns } from "./promt-settings.vue?vue&type=template&id=680889e9&scoped=true"
import script from "./promt-settings.vue?vue&type=script&lang=js"
export * from "./promt-settings.vue?vue&type=script&lang=js"
import style0 from "./promt-settings.vue?vue&type=style&index=0&id=680889e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680889e9",
  null
  
)

export default component.exports